<div class="container-fluid w-100">
  <div class="row justify-content-center">
    <div class="col-12">
        <code-input [codeLength]="6" [code]="value" (codeChanged)="onCodeChanged($event)" (codeCompleted)="onCodeCompleted()"></code-input>
    </div>
  </div>
</div>
